<template lang="pug">
  v-container.d-print-none
    v-row(cols='12' )
      v-col(xs='12' md='8')
        v-container
          v-card( width='100%')
            v-card-title
              span Ordenes de compra
              generar_orden_compra_directamente
            v-card-text
              Tabla_ordenes_de_compras
      v-col(xs='12' md='4' ) 
        v-container#scroll-target.overflow-y-auto(style='max-height: 700px')
          v-row.mb-3
            v-expansion-panels(elevation='0')
              v-expansion-panel
                v-expansion-panel-header 
                  template(v-slot:actions)
                      v-chip.ma-2(color='primary')
                        span {{registro_de_requerimientos.length}}
                  h3.mb-3 Requerimientos de compra 
                v-expansion-panel-content  
                  Tabla_de_requerimientos 
          v-row
            v-card.mb-5(elevation='0')
              v-card-title
                h6.mb-3 Cotizaciones
                v-spacer
                Registrar_cotizacion 
                v-text-field(v-model='search' append-icon='fa-search' label='Buscar cotizaciones' single-line hide-details)
              v-data-table.elevation-1(:headers='headers' :items='registro_cotizaciones' :search='search' sort-by='numero_de_operacion' sort-desc)
                template( v-slot:item.creado_el="{item}" )
                  span {{item.creado_el | imprimir_fecha}}
                template( v-slot:item.action="{item}")
                  estado_de_botones(:estado_del_documento = 'item.estado_del_documento' :id = 'item.id' )  
</template>
<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
export default {
  data: () => ({
    search: '',
    headers: [
      { text: 'Nº',  value: 'numero_de_cotizacion' },
      { text: 'Fecha',  value: 'creado_el' },
      { text: '', value: 'action', sortable: false }
    ],
  }),
  methods: {
    ...mapActions({
      editItem: 'Cotizaciones/get',
      deleteItem: 'Cotizaciones/clean',
      save: 'Cotizaciones/add',
    }),
  },
  computed: {
     ...mapState({
      Cotizaciones :state=> state.Cotizaciones,
      registro_de_requerimientos: state=>state.Requerimientos.record_por_estado,
    }),
    ...mapGetters({
      registro_cotizaciones: 'Cotizaciones/registro',
    })
  },
  
  components:{
    estado_de_botones: ()=>import('../.././componentes/estado_de_botones'),
    Tabla_de_requerimientos: ()=>import('../.././componentes/tabla_de_requerimientos'),
    Registrar_cotizacion: () => import('../../componentes/Registrar_cotizacion'),
    Tabla_ordenes_de_compras: () => import('../../componentes/tabla_ordenes_de_compras'),
    Registrar_cotizacion: () => import('../../componentes/Registrar_cotizacion'),
    generar_orden_compra_directamente:()=> import('../../componentes/generar_orden_compra_directamente')


  }
}
</script>
